import { render } from "./PontajIstoric.vue?vue&type=template&id=997c337a&scoped=true&ts=true"
import script from "./PontajIstoric.vue?vue&type=script&lang=ts"
export * from "./PontajIstoric.vue?vue&type=script&lang=ts"

import "./PontajIstoric.vue?vue&type=style&index=0&id=997c337a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997c337a"]])

export default __exports__